module.exports = __webpack_public_path__ + "media/images/early-music-1-77e9b95d20b98f2b2425fc4f62f206a4.jpg";